import moment from 'moment';
import actions from './orderActions';
import mutations from './orderMutations';

const state = {
  items: [],
  filterDate: moment(),
  filterDateFrom: null,
  filterDateTo: null
};

export default {
  namespaced: true,
  state,
  mutations: mutations,
  actions: actions
}



// WEBPACK FOOTER //
// ./client/store/modules/order/index.js